import api from '.';
import logger from '../utils/logger';
import { EquipmentClassList, EquipmentSortBy } from '../types/equipment';
import { SpecificationFilter } from '../types/filters';

export const getEquipmentSearchResult = async (
  query: string,
  page: number,
  per_page: number,
): Promise<EquipmentClassList> => {
  try {
    const { data } = await api.get(
      `/rental-equipment-search/equipment-classes/search?query=${encodeURIComponent(
        query,
      )}&page=${page}&per_page=${per_page}`,
    );
    return data.data;
  } catch (error) {
    logger(
      'error',
      'at getEquipmentSearchResult while fetching search results for equipmentclasses',
      error,
    );
    throw new Error(
      'error at getEquipmentSearchResult while fetching search results for equipmentclasses',
    );
  }
};

export const getEquipmentClassListSearchResults = async (
  pagination: {
    page: number;
    perPage: number;
  },
  filterBy: {
    equipmentClassIds?: number[];
    categoryId?: number;
    filters?: SpecificationFilter[] | null;
  },
  sortBy?: EquipmentSortBy,
): Promise<EquipmentClassList> => {
  try {
    const { data } = await api.post(
      `/rental-equipment-search/equipment-classes?page=${pagination.page}&per_page=${pagination.perPage}`,
      {
        filter_by: {
          ...(filterBy.equipmentClassIds && { 'equipment-class-id': filterBy.equipmentClassIds }),
          ...(filterBy.categoryId && { 'category-id': filterBy.categoryId }),
          ...(filterBy.filters &&
            filterBy.filters?.length > 0 && { 'spec-filter': filterBy.filters }),
        },
        ...(sortBy && { sort_by: sortBy }),
      },
    );
    return data.data;
  } catch (error) {
    logger(
      'error',
      'at getEquipmentClassListSearchResults while fetching search results for equipmentclasses',
      error,
    );
    throw new Error(
      'error at getEquipmentClassListSearchResults while fetching search results for equipmentclasses',
    );
  }
};
